<template>
  <NetWork v-if="networkError" @refreshs="refresh" ></NetWork>
  <div class="aggregate_cplist" :style="{'height':clientH}" v-else-if="!networkError&&showCpContent">
    <!-- 轮播图 -->
    <div class="aggregate_cplist_banner">
      <Banner></Banner>
    </div>
    <!-- 接单城市 -->
    <div class="aggregate_cplist_orderCity">
      <div>
        <ul>
          <li>接单城市</li>
          <li class="aggregate_cplist_orderCity_city" @click="checkCity">
            <!-- <p><img src="../assets/images/ic_address.png" class="address"/></p> -->
            <p>{{cityName}}</p>
            <p><img src="../assets/images/city_go.png" class="city_go"/></p>
          </li>
        </ul>
      </div>
    </div>
    <!-- 没有加入过cp展示的cp列表 -->
    <div class="aggregate_cplist_list">
      <CpItem :cpList='cpList' title="代驾平台"  btnText="加入" cpName='list' @join='join'></CpItem>
    </div>
  </div>
  <Loading v-else/>
</template>

<script>
// 组件
import Banner from '@/components/banner'
import CpItem from '@/components/cpItem'
import NetWork from '@/components/network'
import Loading from '@/components/loading'
import { handleBuryPoint, buryPoint } from "@/utils/tool.js";
// api
import { reqCpList } from '@/apis/serviceApi'
export default {
  data () {
    return {
      clientH: document.documentElement.clientHeight + 'px',
      show: false,
      tel: '',
      baseInfo: {},
      networkError: false,
      showCpContent: false,
      cityName: '',
      cpList: [],
      lastCpList: [] // 上一次选择的租户
    }
  },
  computed: {
    lastCpLength () {
      return this.lastCpList.length > 0
    }
  },
  mounted () {
    document.title = '司机招募',
    this.getCpList()
    if (this.$route.query.city) {
      this.baseBuryPoint('customerRentedList_PV')
    }
  },
  components: {
    Banner, // 轮播组件
    CpItem,  // 租户列表组件
    NetWork,
    Loading
  },
  methods: {
    // 埋点
    baseBuryPoint(clickId, ext = {}) {
      const { city } = this.$route.query
      let pageId = 'customerRentedList'
      ext.cityName = city
      ext.date = new Date().getTime()
      buryPoint(0, pageId, clickId, ext);
    },
    // 断网刷新逻辑
    refresh () {
      this.getCpList()
    },
    // 选择城市
    checkCity () {
      this.$router.replace({
        path:'cityList',
      })
    },
    // 获取加入过的租户信息
    getLastCpList () {
      const  { cityCode } = this.$route.query
      const lastCpList = JSON.parse(localStorage.getItem(cityCode + 'lastTenantName'))
      console.log(lastCpList,'lastcplist')
      this.lastCpList = []
      this.lastCpList.push(lastCpList)
    },
    closeModal (val) {
      this.show = val
      this.getLastCpList()
    },
    join (baseInfo,isContinue) {
      this.baseInfo = baseInfo
      if (isContinue && isContinue == 'continue') {
        console.log(baseInfo)
        window.location.href = baseInfo.baseInfo.recruitUrl
      } else {
        this.tel =  baseInfo.customerServicePhone
        this.show = true
      }
    },
    getCpList () {
      const { cityCode } = this.$route.query
      reqCpList({adcode: cityCode}).then(res => {
        console.log('cp列表数据===', res)
        if (res.code == 1) {
          this.showCpContent = true
          this.networkError = false
          this.cpList = res && res.data && res.data.baseInfo
          this.cityName = this.cpList[0].baseInfo.cityName
          if (this.cpList.length > 0) {
            this.lastCpList = []
            const lastCpList = JSON.parse(localStorage.getItem(cityCode + 'lastTenantName')) || []
            this.cpList.forEach((item, index) => {
              let result = this.cpList.find(cItem => {
                  return cItem.baseInfo.tenantName == lastCpList.baseInfo.tenantName ;
              });
              if (result) {
                const tenantName = `${cityCode + item.baseInfo.tenantName}`
                const lastTenantName = `${cityCode + lastCpList.baseInfo.tenantName}`
                if (tenantName === lastTenantName) {
                  this.getLastCpList()
                }
              } else {
                localStorage.removeItem(cityCode + 'lastTenantName')
              }
            })
          } else {
            localStorage.removeItem(cityCode + 'lastTenantName')
          }
        } else {
          this.showCpContent = false
          this.networkError = true
        }
      })
      .catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style lang='less' scoped>
.aggregate_cplist{
  flex-wrap: wrap;
  background: #f7f7f7;
  .aggregate_cplist_orderCity{
    width: 690px;
    margin: 0 auto;
    background: #ffffff;
    box-sizing: border-box;
    min-height: 92px;
    box-shadow: 0 8px 16px 2px rgba(0,0,0,0.04);
    border-radius: 10px;
    min-height: 92px;
    padding: 0 26px;
    margin-top:30px;
    font-weight: 500;
    ul{
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 36px;
      color: #333333;
      li{
        font-weight: bold
      }
    }
    .aggregate_cplist_orderCity_city{
      display: flex;
      align-items: center;
      font-size: 36px;
      line-height: 92px;
      color: #176AF0;
      .address{
        width:40px;
        height: 40px;
        margin-bottom: 8px;
        margin-right: 8px;
      }
      .city_go{
        width: 18px;
        height: 32px;
        margin-bottom: 8px;
        margin-left: 12px;
      }
    }
}
}

</style>